import { createContext, useContext, useState } from "react";

/* 208 */
import p208card from "../assets/molelos/208/208.webp";
import p208card2 from "../assets/molelos/208/208b.webp";
import p208card3 from "../assets/molelos/208/208n.webp";
import hero208 from "../assets/hero.webp";
import p2081 from "../assets/molelos/208/2081.webp";
import p2082 from "../assets/molelos/208/2082.webp";
import p2083 from "../assets/molelos/208/2083.webp";
import p2084 from "../assets/molelos/208/2084.webp";
import p2085 from "../assets/molelos/208/2085.webp";
import p2086 from "../assets/molelos/208/2086.webp";

/* Partner */
import partnercard from "../assets/molelos/partner/partner.png";
import heropartner from "../assets/molelos/partner/partnerhero.webp";
import partner1 from "../assets/molelos/partner/partner1.png";
import partner2 from "../assets/molelos/partner/partner2.png";
import partner3 from "../assets/molelos/partner/partner3.png";
import partner4 from "../assets/molelos/partner/partner4.png";

/* Expert */
import expertcard from "../assets/molelos/expert/expert.webp";
import heroexpert from "../assets/molelos/expert/experthero.webp";
import expert1 from "../assets/molelos/expert/expert1.webp";
import expert2 from "../assets/molelos/expert/expert2.webp";
import expert3 from "../assets/molelos/expert/expert3.webp";

export const ConsContext = createContext();

export const useCons = () => {
  const context = useContext(ConsContext);
  if (!context) throw new Error("useCons must be used within a ConsContext");
  return context;
};

export const ConsContextProvider = ({ children }) => {
  const [popActive, setPopActive] = useState({
    active: false,
    clickModel: "",
  });

  const buttonData = (active, clickModel, modelName) => {
    setPopActive({
      active: active,
      clickModel: clickModel ? clickModel : "",
    });
    try {
      dataLayer.push({
        event: "CTA",
        model: modelName ? modelName : "Header",
      });
    } catch (error) {
      console.log(error);
    }
  };

  const prices = {
    p208easy: { cuota: "345.000" },
    p208plus: { cuota: "469.000" },
    p208tiptronic: { cuota: "572.000" },
    partner: { cuota: "480.000" },
    p2008active: { cuota: "542.000" },
    p2008allure: { cuota: "730.000" },
    expert: { cuota: "694.000" },
  };

  const modelos = [
    {
      id: 1,
      link: "plan-208",
      nombre: "208 Like",
      modelo: "208",
      color: "#e6e6e6",
      text: "black",
      cuota: prices.p208easy.cuota,
      plan: "Plan 70/30 · 120 Cuotas",
      text1: "Pagalo hasta en 120 Cuotas",
      text2: "Retirá en Mes 6 con el 60% o en Mes 12 con 30%",
      img: hero208,
      galeria: [p2081, p2082, p2083, p2084, p2085, p2086],
      card: p208card,
      cupo: 6,
      dataButton: "PLAN 208",
      disabled: false,
    },
    {
      id: 2,
      link: "plan-208-plus",
      nombre: "208 Allure Plus",
      modelo: "208",
      color: "#e6e6e6",
      text: "black",
      cuota: prices.p208plus.cuota,
      plan: "Plan 80/20 · 84 Cuotas",
      text1: "Pagalo en 84 Cuotas",
      text2: "Retirá en Mes 6 con el 60% o en Mes 12 con 30%",
      img: hero208,
      galeria: [p2081, p2082, p2083, p2084, p2085, p2086],
      card: p208card2,
      cupo: 6,
      dataButton: "PLAN 208 PLUS",
      disabled: false,
    },
    {
      id: 3,
      link: "plan-208-tiptronic",
      nombre: "208 Allure Tiptronic",
      modelo: "208",
      color: "#e6e6e6",
      text: "black",
      cuota: prices.p208tiptronic.cuota,
      plan: "Plan 100% Financiado · 84 Cuotas",
      text1: "Pagalo en 84 Cuotas",
      text2: "Financiación total sin anticipo",
      img: hero208,
      galeria: [p2081, p2082, p2083, p2084, p2085, p2086],
      card: p208card3,
      cupo: 6,
      dataButton: "PLAN 208 TIPTRONIC",
      disabled: false,
    },
    {
      id: 4,
      link: "plan-2008-active",
      nombre: "2008 Active",
      modelo: "2008",
      color: "#e6e6e6",
      text: "black",
      cuota: prices.p2008active.cuota,
      plan: "Plan 80/20 · 84 Cuotas",
      text1: "Pagalo en 84 Cuotas",
      text2: "Retirá en Mes 6 con el 60% o en Mes 12 con 30%",
      img: hero208,
      galeria: [p2081, p2082, p2083, p2084, p2085, p2086],
      card: p208card,
      cupo: 6,
      dataButton: "PLAN 2008 ACTIVE",
      disabled: false,
    },
    {
      id: 5,
      link: "plan-2008-allure",
      nombre: "2008 Allure",
      modelo: "2008",
      color: "#e6e6e6",
      text: "black",
      cuota: prices.p2008allure.cuota,
      plan: "Plan 100% Financiado · 84 Cuotas",
      text1: "Pagalo en 84 Cuotas",
      text2: "Financiación total sin anticipo",
      img: hero208,
      galeria: [p2081, p2082, p2083, p2084, p2085, p2086],
      card: p208card,
      cupo: 6,
      dataButton: "PLAN 2008 ALLURE",
      disabled: false,
    },
    {
      id: 6,
      link: "plan-partner",
      nombre: "Partner",
      modelo: "Partner",
      color: "#e6e6e6",
      text: "black",
      cuota: prices.partner.cuota,
      plan: "Plan 70/30 · 84 Cuotas",
      text1: "Pagalo en 84 Cuotas",
      text2: "Tomamos tu Usado Llave por Llave",
      img: heropartner,
      galeria: [partner1, partner2, partner3, partner4],
      card: partnercard,
      cupo: 3,
      dataButton: "PLAN PARTNER",
      disabled: false,
    },
    {
      id: 7,
      link: "plan-expert",
      nombre: "Expert L3 HDI",
      modelo: "Expert",
      color: "#e6e6e6",
      text: "black",
      cuota: prices.expert.cuota,
      plan: "Plan 70/30 · 84 Cuotas",
      text1: "Pagalo en 84 Cuotas",
      text2: "Tomamos tu Usado Llave por Llave",
      img: heroexpert,
      galeria: [expert1, expert2, expert3],
      card: expertcard,
      cupo: 3,
      dataButton: "PLAN EXPERT",
      disabled: false,
    },
  ];

  const modelsOptions = modelos.map((model) => {
    return {
      value: model.dataButton,
      text: `${model.dataButton} (Cuota $${model.cuota})`,
      disabled: model.disabled,
    };
  });

  console.log(modelsOptions);

  return (
    <ConsContext.Provider
      value={{
        popActive,
        setPopActive,
        prices,
        buttonData,
        modelos,
        modelsOptions,
      }}
    >
      {children}
    </ConsContext.Provider>
  );
};
